import { FILE_NAME, LOG_TYPE } from './../config/API_DATA'
import BaseConfiguration from "../config/base";
import Logger from "./../services/logger";
import store from './index'
export function clearStore() {
    try {
        if (BaseConfiguration.isDebug) console.log("clearStore");

        store.dispatch("sAgtLogin/CLEAR_AGT_LOGIN");
        store.dispatch("sAddUser/CLEAR_ADD_USER_STORE");
        store.dispatch("sApproveAgt/CLEAR_APPROVE_AGT_STORE");
        store.dispatch("sChangePassword/CLEAR_CHANGE_PWD_STORE");
        store.dispatch("sUserRoles/CLEAR_USER_ROLES_STORE");
        store.dispatch("sManageUsers/CLEAR_MANAGE_USERS_STORE");
        store.dispatch("sRolesPermissions/CLEAR_ROLES_PERMISSIONS_STORE");
        store.dispatch("sExchangeRate/CLEAR_EXCHANGE_RATE_STORE");
        store.dispatch("sCLanguagePicker/CLEAR_C_LANGUAGEPICKER_STORE");
        store.dispatch("sCountryList/CLEAR_COUNTRY_LIST_STORE");
        store.dispatch("sCurrencyLs/CLEAR_CURRENCY_LIST_STORE");
        store.dispatch("sStateList/CLEAR_STATE_LIST_STORE");
        
        store.dispatch("sSysLogin/CLEAR_SYS_LOGIN");
        store.dispatch("sMenus/CLEAR_ALL_MENUS_STORE");
        store.dispatch("sCreatePricing/CLEAR_CREATE_PRICING_STORE");
        store.dispatch("sCAgent/CLEAR_C_AGENT_STORE");
        store.dispatch("sCMultiCitySearch/CLEAR_C_ML_SEARCH_STORE");

        store.dispatch("sCSearch/CLEAR_CSEARCH_STORE");
        store.dispatch("sHotelSearch/CLEAR_HOTEL_SEARCH_STORE");
        store.dispatch('sPaymentSetup/CLEAR_PAYMENT_STORE');
        store.dispatch('sDashBoard/CLEAR_AGENT_LOGO_STORE');
        store.dispatch('sSystemTopUp/CLEAR_SYSTEM_TOPUP_STORE')

        store.dispatch('sPrepaidTopUp/CLEAR_PREPAID_TOPUP_STORE')
        store.dispatch('cBookingDetail/CLEAR_BOOKING_DETAIL_STORE')
        store.dispatch('cTicketingDetail/CLEAR_TICKETING_DETAIL_STORE')
        store.dispatch('sAllExchange/CLEAR_ALL_EXCHANGE_STORE')
        store.dispatch('sAllRefund/CLEAR_ALL_REFUND_STORE')

        store.dispatch('sTicketingQueue/CLEAR_TICKETING_QUEUE_STORE')
        store.dispatch('sPaymentPage/CLEAR_PAYMENT_STORE')
        store.dispatch('sManageAgent/CLEAR_MANAGE_AGENT_STORE')
        store.dispatch('sCOrgCurrencyDp/CLEAR_C_ORG_CURRENCY_STORE')
        store.dispatch('sAssignPricing/CLEAR_ASSIGN_PRICING_STORE')
        store.dispatch('sCAirLine/CLEAR_C_AIRLINE_STORE')
        store.dispatch('sManagePricing/CLEAR_MANAGE_PRICING_STORE')
        store.dispatch('sSetupPricing/CLEAR_SETUP_PRICING_STORE')
        store.dispatch('sResult/CLEAR_RESULT_STORE')
        store.dispatch('sPaxPage/CLEAR_PAX_STORE')
        store.dispatch('sCaptcha/CLEAR_CAPTCHA_STORE')
        store.dispatch('sAgtReg/CLEAR_AGT_REG_STORE')
        store.dispatch('sPostPaidTopUp/CLEAR_POSTPAID_TOPUP_STORE')
        store.dispatch('sPaymentStatus/CLEAR_PAYMENT_STATUS_STORE')
        store.dispatch('sCPaymentList/CLEAR_C_PAYMENT_LIST_STORE')
        store.dispatch('sMLResult/CLEAR_ML_RESULT_STORE')
        store.dispatch('sCSystemDeposit/CLEAR_C_SYSTEM_DEPOSIT_STORE')

        store.dispatch("sFlightSchedule/CLEAR_FLIGHT_SCHEDULE_STORE");
        store.dispatch("sContract/CLEAR_CONTRACT_STORE");
        store.dispatch('sGuide/CLEAR_GUIDE_STORE')
        store.dispatch('sRefundDetail/CLEAR_REFUND_DETAIL_STORE')

        store.dispatch('sExchangeDetail/CLEAR_EXCHANGE_DETAIL_STORE')
        store.dispatch('sCreditSaleReport/CLEAR_CREDIT_SALE_REPORT_STORE')

        store.dispatch('sHotelResult/CLEAR_RESULT_STORE')

        store.dispatch('sHotelRoomResult/CLEAR_HOTEL_ROOM_RESULT_STORE')
        store.dispatch('sGuestPage/CLEAR_PAX_STORE')

        store.dispatch('sTariff/CLEAR_TARIFF_STORE')
        store.dispatch('sRatePlan/CLEAR_RATE_PLAN')
        store.dispatch('sRatePlan/CLEAR_RATE_PLAN')
      //  store.dispatch('sHotelInfo/CLEAR_HOTEL_INFO_STORE')
        store.dispatch('shmsManage/CLEAR_HOTEL_STORE')
        store.dispatch('sSupplierGrp/CLEAR_SUPPLIER_GRP_STORE')
        store.dispatch('sHotelTax/CLEAR_TAX_STORE')
        store.dispatch('sHotelInfo/CLEAR_HOTEL_INFO_STORE')
        store.dispatch('sHmsUser/CLEAR_HMS_USER_STORE')




    } catch (err) {
        let body = Logger.buildRequest(
            FILE_NAME.CLEAR_STORE,
            "error in clearStore",
            err.toString(),
            "clearStore",
            LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
    }

}